 /*
 * @Author: chenhui@didichuxing.com
 * @Date: 2018-12-17
 * @Description:  x推c落地页奖励详情页
 * @Updated: CGC-拼团mvp-奖品
 */
<template>
  <div class="xtc-reward-container">
    <RewardList
    v-if="isMvp"
    :emptyStatus="emptyStatus"
    :size="size"
    :loading="loading"
    :offset="offset"
    :onFetchlist="onFetchlist"
    @itmCls="itmCls"
    @formatSubtext="formatSubtext"
    />
    <template v-else>
      <div class="xtc-reward-container-tabbar" v-show="rewardedAmountTemp">
        <div class="content">
          <div class="item">
            <p class="money" v-html="rewardedAmountTemp"></p>
            <span class="status">{{gettext('已获得奖励')}}</span>
          </div>
          <div class="line"></div>
          <div class="item">
            <p class="money" v-html="pendingAmountTemp"></p>
            <span class="status">{{gettext('待入账奖励')}}</span>
          </div>
        </div>
      </div>
      <div class="xtc-reward-container-body" :style="{background: loading ? 'transparent': '#fff'}" v-if="meanfulGlobalParams">
        <div class="list-wraper">
          <rich-recycle-list class="list" v-if="!emptyStatus" :size="size" :on-fetch="onFetchlist" :offset="offset">
            <template slot="item" slot-scope="{ data }" class="list-itm">
              <rich-cell
                :class="itmCls(data)"
                :id="data.nickName"
                @click="() => {}"
                :label="(+data.rewardStatus !== 2) ? (data.info || data.rewardTimeDisplay) : ''"
                :title="data.nickName"
                :value="formatSubtext(data.amountSplit, data.info, data, data.amount)"
              >
              <img slot="icon" :src="data.headImg" width="24" height="24" class="headImg" v-if="data.headImg">
              <img slot="icon" src="../../../assets/images/xtc/headimg@2x.png" width="24" height="24" class="headImg" v-else>
              </rich-cell>
            </template>
          </rich-recycle-list>
          <div class="empty-status" v-else>
            <img src="../../../assets/images/xtc/empty.png" />
            <p class="empty-title">{{$t('FoodC_all_No_reward_ocGJ')}}</p>
            <p class="empty-explain">{{$t('FoodC_all_You_haven_lSmt')}}</p>
          </div>
        </div>
      </div>
    </template>
    <loading-mask v-if="loading"></loading-mask>
  </div>
</template>
<script>
import RewardList from './landingPage/group_mvp_reward_list'
import LoadingMask from '@/components/loading/loading-mask'
import API from '@/api'
import { mapGetters, mapActions } from 'vuex'
import { setTitle } from '@/common/js/bridge'
import { getActivityType, getAmountTmpl, getIntNumFromAmount } from '@/common/js/utils'
import trackEvent from '@/common/js/track'

export default {
  name: 'historyList',
  components: {
    RewardList,
    LoadingMask
  },
  data () {
    return {
      listInfo: {},
      size: 15,
      offset: 1,
      pageCount: -1,
      // rich-recycle 阻止下拉fetch事件 polyfill
      cancelFetch: false,
      emptyStatus: false,
      nick: 'friend',
      loading: true
    }
  },
  created () {
    setTitle(this.$route.query.activityId ? this.gettext('阶梯奖励') : this.gettext('我的奖励'))
    this.getGlobalInfo()
      .catch(err => {
        const toast = this.$createToast({
          time: 3000,
          txt: err,
          type: 'error'
        })
        toast.show()
      })
  },
  mounted () {
    trackEvent({
      eventId: 'sailing_c_x_invitedetail_common_sw',
      eventLabel: '推荐有奖详细信息页面展示',
      attrs: {
        activity_id: this.$route.query.activityId || '',
        rewarded_num: this.rewardedAmountTemp,
        pending_num: this.pendingAmountTemp
      }
    })
  },
  computed: {
    ...mapGetters(['globalParams', 'acquisitionInfo']),
    meanfulGlobalParams () {
      // return this.globalParams && this.globalParams.token
      return {}
    },
    rewardedAmountTemp () {
      if (this.listInfo.rewardedAmountSplit) {
        const splitData = {
          split: this.numfilter(this.listInfo.rewardedAmountSplit),
          symbolClass: 'symbol',
          numberClass: 'amount'
        }
        return getAmountTmpl(splitData)
      }
      return ''
    },
    pendingAmountTemp () {
      if (this.listInfo.pendingAmountSplit) {
        const splitData = {
          split: this.numfilter(this.listInfo.pendingAmountSplit),
          symbolClass: 'symbol',
          numberClass: 'amount'
        }
        return getAmountTmpl(splitData)
      }
      return ''
    },
    isMvp () {
      const rewardType = this.$route.query.rewardType || ''
      return rewardType === 'mvp'
    }
  },
  methods: {
    ...mapActions(['getGlobalInfo']),
    itmCls (data) {
      switch (data.rewardStatus) {
        case 1: return 'itm-black'
        case 0: return 'itm-grey'
        default: return 'itm-red'
      }
    },
    numfilter (amountSplit) {
      return {
        'symbol': amountSplit.symbol,
        'number': getIntNumFromAmount(amountSplit.number),
        'position': amountSplit.position,
        'display': amountSplit.display,
        'sign': amountSplit.sign
      }
    },
    formatSubtext (amountSplit, subText, obj, amountNum) {
      let resultText = ''
      if (amountSplit && amountNum > 0) {
        resultText = amountSplit.position ? `${amountSplit.number}${amountSplit.symbol}` : `${amountSplit.symbol}${amountSplit.number}`
        if (+obj.rewardStatus === 0) {
          resultText = resultText + this.gettext('待入账')
        } else if (+obj.rewardStatus === 1) {
          resultText = resultText + ''
        } else {
          resultText = this.gettext('已过期')
        }
      }
      return resultText
    },
    setBannerData (data) {
      if (!this.listInfo || !this.listInfo.hasOwnProperty('rewardedAmount')) {
        this.listInfo = data
      }
    },
    fetchAcquisitionReferralList (data) {
      if (this.isMvp) {
        return API.acquisitionMvpReferralList(data)
          .then((res) => {
            if (res && res.errno === 0 && res.data) {
              return res.data
            } else {
              throw res && res.errmsg
            }
          })
          .catch(err => {
            const toast = this.$createToast({
              time: 3000,
              txt: err,
              type: 'error'
            })
            toast.show()
          })
      } else {
        return API.acquisitionReferralList(data)
          .then((res) => {
            if (res && res.errno === 0 && res.data) {
              return res.data
            } else {
              throw res && res.errmsg
            }
          })
          .catch(err => {
            const toast = this.$createToast({
              time: 3000,
              txt: err,
              type: 'error'
            })
            toast.show()
          })
      }
    },
    onFetchlist () {
      if (this.pageCount !== 0) {
        let activityType = getActivityType(this.globalParams.businessType)
        if (this.cancelFetch) return Promise.resolve(false)
        return new Promise((resolve, reject) => {
          this.fetchAcquisitionReferralList({
            token: this.globalParams.token,
            poiLng: this.globalParams.poiLng,
            poiLat: this.globalParams.poiLat,
            activityId: this.$route.query.activityId || 0,
            code: (this.acquisitionInfo && this.acquisitionInfo.recommendCode) || '',
            activityType: activityType,
            page: this.offset++,
            pageSize: this.size
          }).then((res) => {
            if (this.pageCount === -1) {
              this.pageCount = Math.ceil(res.pageInfo.total / this.size)
            }
            this.pageCount--
            this.setBannerData(res)
            if (Array.isArray(res.rewardList) && res.rewardList.length) {
              this.emptyStatus = false
              resolve(res.rewardList)
            } else {
              this.cancelFetch = true
              this.emptyStatus = true
              resolve(false)
            }
          })
            .finally(() => {
              this.loading = false
            })
        })
      } else {
        return Promise.resolve(false)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "~@/common/stylus/base"
@import "~@/common/stylus/variables";
@import "~@/assets/styles/main.scss";
@import '~@/common/stylus/mixin.styl';
.xtc-reward-container {
  width: 100%
  height: 100%
  overflow: hidden
  background: white
  font-size: 0.625rem
  background #f7f7f7
  .no-px2rem {
    border-1px(#E5E5E5, 4px, solid)
  }
  .empty-status {
    margin-top: 200px;
    color: #000000;
    display flex;
    align-items: center;
    justify-items: flex-start;
    flex-direction: column;
    img {
      width: 288px;
      height: 288px;
    }
    .empty-title {
      height: 48px;
      line-height: 48px;
      font-family: 'Aspira Medium';
      font-size: 36px;
      text-align: center;
      font-weight: 500;
    }
    .empty-explain {
      margin-top: 5px;
      width: 500px;
      font-family: 'Aspira Light';
      font-size: 24px;
      text-align: center;
      line-height: 30px;
      font-weight: 200;
    }
  }
  &-tabbar {
    margin: 20px 24px
    display: flex
    justify-content: center
    background: #FFFFFF
    border-radius: 12px
    .content {
      width: 100%
      height 176px
      display: flex
      justify-content: space-around
      align-items: center
      .item {
        flex: 1
        text-align: center
        .money {
          font-size 40px
          display: flex;
          justify-content: center;
        }
        .status {
          margin-top 12px
          font-family 'Aspira Light'
          font-size 24px
          color #000000
          display block
        }
      }
      .item /deep/ .symbol {
        font-family 'Aspira Medium'
        font-size 40px
        color #000000
        display inline-block
        color #333333
        line-height 40px
        vertical-align middle
      }
      .item /deep/ .amount {
        font-family 'Aspira Medium'
        font-size 40px
        color #000000
        display inline-block
        color #333333
        line-height 40px
        vertical-align middle
      }
      .line {
        width 1px
        height 102px
        background rgba(0, 0, 0, .08)
      }
    }
  }
  &-body{
    margin 0 24px
    height calc(100% - 236px)
    background #ffffff
    border-radius 12px
    padding 0 32px
    overflow hidden
    .headImg {
      position: absolute
      left: 0
      top: 22px
      width: 80px
      height: 80px
      border: 0
      background: url("~@/assets/images/xtc/headimg@2x.png") no-repeat
      background-size: 80px 80px
      border-radius: 80px
    }
    .list-wraper {
      height 100%
      width 100%
      border-radius 12px
      overflow hidden
      & /deep/ .rich-recycle-list {
        // 滚动条撑开 隐藏滚动条
        padding-right 20px
        margin-right -20px
      }
      & /deep/ .rich-recycle-list-loading {
        display none
      }
      & /deep/ .rich-recycle-list-noMore {
        display none
      }
    }
    & /deep/ .rich-recycle-list-items {

      .rich-recycle-list-item:nth-last-child(2) {
        background red
        .border-bottom-1px {
          border-bottom none
        }
      }
    }
    >>> .rich-cell {
      height 138px
      .border-bottom-1px {
        border-bottom: 1px solid #EBEBEB
        &::after {
          display none
        }
      }
      .rich-cell-title {
        margin-left: 80px
        .rich-cell-text {
          font-family 'Aspira Medium'
          font-size 32px
          color #000000
          text-align left
          line-height 32px
        }
        .rich-cell-label {
          font-family 'Aspira Light'
          font-size 24px
          color #000000
          text-align left
          line-height 24px
        }
      }
      .rich-cell-wrapper {
        height 138px
        align-items center
        padding-right 20px
        img {
          top auto
        }
        .rich-cell-wrapper:after {
          border-bottom: 1px #e5e5e5 solid
        }
      }
      .rich-cell-wrapper:first-child {
        &:after {
          border-color: #ff0000
          transform: scale(.5)
        }
      }
      &.itm-black {
        .rich-cell-wrapper .rich-cell-value{
          font-family 'Aspira Medium'
          font-size 32px
          color #000000
          text-align left
        }
      }
      &.itm-red {
        .rich-cell-wrapper .rich-cell-value{
          font-family 'Aspira Light'
          font-size 24px
          color #ED2D2D
          text-align left
        }
      }
      &.itm-grey {
        .rich-cell-wrapper .rich-cell-value{
          font-family 'Aspira Light'
          font-size 24px
          color #999999
          text-align left
        }
      }
    }
  }
}
</style>
